module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("© 2014 Bruce K. Waltke, James M. Houston, and Erika Moore")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Published 2014 by")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Wm. B. Eerdmans Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("P.O. Box 163, Cambridge CB3 9PU U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Waltke, Bruce K.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("The Psalms as Christian lament: a historical commentary /")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Bruce K. Waltke, James M. Houston, and Erika Moore.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 978-0-8028-6809-1 (pbk.: alk. paper); 978-1-4674-4064-6 (ePub); 978-1-4674-4022-6 (Kindle)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("1. Bible. Psalms — Criticism, interpretation, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("2. Laments in the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("BS1445.L3W35 2014")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("223′.206 — dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("2013048119")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b4b40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-psalmschristian-0004.vue
// module id = 63
// module chunks = 0